import { ReactNode } from 'react';

type NsInputProps = {
  id?: string;
  testId?: string;
  type?: 'text' | 'email' | 'tel' | 'number' | 'radio' | 'checkbox' | 'search';
  label?: ReactNode;
  name?: string;
  pattern?: string;
  value?: string | boolean;
  children?: ReactNode;
  inputAttributes?: Record<string, string | boolean>;
  min?: string | number;
  max?: string | number;
  placeholder?: string;
};

export const NsInput = ({
  id = 'input',
  name = 'input',
  label = 'label',
  type = 'text',
  inputAttributes = {},
  value = '',
  min,
  max,
  pattern,
  testId,
  placeholder = ''
}: NsInputProps) => {
  const slot: string | undefined =
    type !== 'radio' && type !== 'checkbox' ? 'label' : undefined; //TO DO: review needed if undefined is ok instead of null.

  return (
    <>
      <input
        {...inputAttributes}
        type={type}
        id={id}
        name={name}
        min={min}
        max={max}
        pattern={pattern}
        defaultValue={
          typeof value === 'string' || typeof value === 'number' ? value : ''
        } // use defaultValue because React thinks we don't have an onChange event handler
        data-testid={testId}
        placeholder={placeholder}
      />
      <label slot={slot} htmlFor={id}>
        {label}
      </label>
    </>
  );
};
